import React from "react";
import "./Footer.scss";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-logo-box">
        <img
          src="img/AmirRezaTamandaniLogoWhite.png"
          alt="my logo"
          className="footer-logo"
        />
      </div>
      <div className="row">
        <div className="col-1-of-2">
          <div className="footer-navigation">
            <ul className="footer-list">
              <li className="footer-item">
                <a
                  href="https://www.linkedin.com/in/amir-reza-tamandani"
                  className="footer-link"
                >
                  linkedin
                </a>
              </li>
              <li className="footer-item">
                <a href="https://t.me/azmonios" className="footer-link">
                  Telegram
                </a>
              </li>
              <li className="footer-item">
                <a
                  href="https://gitlab.com/AmirRezaTamanadani"
                  className="footer-link"
                >
                  gitlab
                </a>
              </li>
              <li className="footer-item">
                <a href="https://github.com/AmirTaman" className="footer-link">
                  github
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-1-of-2">
          <p className="footer-copyright">
            built by AmirReza Tamandani using pure SASS/SCSS and powered by
            react js (credit to jonas schmedtmann for his awesome designs)
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
